<template>
    <div class="notaryServices"  :style="{
            minHeight: `calc(100vh - ${topHeight || 0}px )`,
        }">
             <banner :themeColor="'#fff'"></banner>  
             <div ref="notaryServicesref" class="notaryServices_content">
                <!-- 公证服务 -->
                <div class="notaryServices_content_title">公证服务</div>
                <div class="notaryServices_content_title_main">
                    <div class="notaryServices_content_title_img">
                        <img src="../../assets/images/notaryServicers/szh.png" alt="">
                    </div>
                     <div class="notaryServices_content_title_text">
                        我们的平台公证业务，融合法定权威与数字技术，打造全场景法律证明体系。业务事项丰富，民事涵盖合同、继承等公证，商事涵盖商事、章程公证，还能做证据、文证公证。同时提供登记、提存保管、文书代拟及法律咨询等事务服务。借助区块链存证，让公证文书具直接证据效力，以第三方身份为合作交往筑牢法律后盾。
                    </div>
                </div>
                <!-- 我们公证的优势 -->
                <div class="notaryServices_content_title">我们公证的优势</div>
                <div class="notaryServices_content_szh">
                     <div class="notaryServices_content_szh_item">
                          <div class="notaryServices_content_szh_item_img"><img src="../../assets/images/notaryServicers/szh1.png" alt=""></div>
                          <div class="notaryServices_content_szh_item_text">效率跃升</div>
                     </div>
                      <div class="notaryServices_content_szh_item">
                          <div class="notaryServices_content_szh_item_img"><img src="../../assets/images/notaryServicers/szh2.png" alt=""></div>
                          <div class="notaryServices_content_szh_item_text">成本优化</div>
                     </div>
                     <div class="notaryServices_content_szh_item">
                          <div class="notaryServices_content_szh_item_img"><img src="../../assets/images/notaryServicers/szh3.png" alt=""></div>
                          <div class="notaryServices_content_szh_item_text">体验升级</div>
                     </div>
                     <div class="notaryServices_content_szh_item">
                          <div class="notaryServices_content_szh_item_img"><img src="../../assets/images/notaryServicers/szh4.png" alt=""></div>
                          <div class="notaryServices_content_szh_item_text">风险管控</div>
                     </div>
                </div>
                <!-- 公证业务范围 -->
                 <div class="notaryServices_content_title">公证业务范围</div>
                  <div class="notaryServices_gzyw">
                    <div class="notaryServices_gzywimg">
                         <div class="notaryServices_background">公证事项</div>
                    </div>
                     <div class="notaryServices_gzywtext">
                        <div class="notaryServices_gzywtext_title">公证事项</div>
                        <div class="notaryServices_gzywtext_item">
                              <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx1.png" alt="">
                                </div>
                                 <div class="grid-content_text">合同公证</div>
                                </div>
                              </div>
                               <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx2.png" alt="">
                                </div>
                                 <div class="grid-content_text">继承公证</div>
                                </div>
                              </div>
                                 <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx3.png" alt="">
                                </div>
                                 <div class="grid-content_text">意定公证</div>
                                </div>
                              </div>
                            <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx4.png" alt="">
                                </div>
                                 <div class="grid-content_text">财产公证</div>
                                </div>
                              </div>
                            <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx5.png" alt="">
                                </div>
                                 <div class="grid-content_text">商事公证</div>
                                </div>
                              </div>
                        </div>
                           <div class="notaryServices_gzywtext_item" style="margin-top: 20px;">
                              <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx6.png" alt="">
                                </div>
                                 <div class="grid-content_text">亲属公证</div>
                                </div>
                              </div>
                               <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx7.png" alt="">
                                </div>
                                 <div class="grid-content_text">身份公证</div>
                                </div>
                              </div>
                                 <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx8.png" alt="">
                                </div>
                                 <div class="grid-content_text">章程公证</div>
                                </div>
                              </div>
                            <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx9.png" alt="">
                                </div>
                                 <div class="grid-content_text">证据公证</div>
                                </div>
                              </div>
                            <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx10.png" alt="">
                                </div>
                                 <div class="grid-content_text">文证公证</div>
                                </div>
                              </div>
                        </div>
                         <div class="notaryServices_gzywtext_title">公证事务</div>
                                <div class="notaryServices_gzywtext_item" >
                              <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx11.png" alt="">
                                </div>
                                 <div class="grid-content_text">法定登记</div>
                                </div>
                              </div>
                               <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx12.png" alt="">
                                </div>
                                 <div class="grid-content_text">提存事务</div>
                                </div>
                              </div>
                                 <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx13.png" alt="">
                                </div>
                                 <div class="grid-content_text">保管事务</div>
                                </div>
                              </div>
                            <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx14.png" alt="">
                                </div>
                                 <div class="grid-content_text">文书代拟</div>
                                </div>
                              </div>
                            <div class="notaryServices_gzywtext_item_flex">
                                <div class="grid-content ep-bg-purple" >
                                <div class="grid-content_img">
                                    <img src="../../assets/images/notaryServicers/gzsx15.png" alt="">
                                </div>
                                 <div class="grid-content_text">公证法律</div>
                                </div>
                              </div>
                        </div>
                    </div>
                </div>
                <!-- 定制化公证咨询服务 -->
                <customization :themeColor="themeColor"></customization>
             </div>
    </div>
</template>
 
<script>
import { getCurrentInstance,ref,watch,computed,onMounted,nextTick} from "vue";
import { useRoute, useRouter } from "vue-router";
import customization from "./components/customization.vue";
import banner from '@/components/banner.vue'
export default {
  name: "notaryServices",
    props:{
    themeColor: {
        type: String,
        default: 'blue'
    },
        topHeight: {
        type: Number,
        default: 0
      }
  },
    components:{
        customization,
        banner
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let articleData = ref({});
    const ruleFormRef=ref(null)
    const ruleForm= ref({})
    let articleId=ref(route.query.articleId);
    const getDetails=()=>{
      proxy.$request({
        url: "INDUSTRYARTICLEMAGE_FINDINFO",
        method: "post",
        data:{
          "id":articleId.value
        }
      }).then((res) => {
        if (res.data.code == "000") {
          let result=res.data.result;
          if(result.attachmentsUrl){
            result.attachmentsUrlArr=JSON.parse(result.attachmentsUrl);
          }else{
            result.attachmentsUrlArr=[];
          }
          result.attachmentsUrlArr.map(item=>[
            item.type=item.url.split(".")[1]
          ])
          articleData.value=result;
        }
      }).catch((err) => {
        console.log(err);
      });
		}
        const notaryServicesref = ref(null);
        const footerHeight = ref(0);
        onMounted(async () => {
        await nextTick();
        if(notaryServicesref.value){
            footerHeight.value = notaryServicesref.value.offsetHeight
        }
        
            window.addEventListener('resize', ()=>{
            if(notaryServicesref.value){
                footerHeight.value = notaryServicesref.value.offsetHeight
            }
            });
        });
    return {
      articleData,
      notaryServicesref,
      ruleForm,
      ruleFormRef
    };
  },
};
</script>

 
<style lang="less" scoped>
.notaryServices {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    box-sizing: border-box;
    padding-bottom: 50px;
    .notaryServices_content {
        // padding: 0 150px;
        width: 1200px;
        margin: 0 auto;
         box-sizing: border-box;
        .notaryServices_content_title {
             box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 50px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 30px;
            color: #313A4B;
            line-height: 42px;
        }
        .notaryServices_content_title_main {
             box-sizing: border-box;
            display: flex;
            margin-top: 30px;
            .notaryServices_content_title_img {
                 box-sizing: border-box;
                width: 386px;
                height: 220px;
                
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .notaryServices_content_title_text {
                 box-sizing: border-box;
                padding: 0 65px 0 47px;
                flex: 1;
                background: #F9FAFC;
                font-weight: 400;
                font-size: 14px;
                color: #57647C;
                line-height: 32px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .notaryServices_content_szh {
             box-sizing: border-box;
                margin-top: 50px;
                display: flex;
             .notaryServices_content_szh_item:nth-child(odd){
                     border-bottom: 4px solid #0754BD;
             }   
             .notaryServices_content_szh_item:nth-child(even){
                     border-bottom: 4px solid #FF8500;
             }  
            .notaryServices_content_szh_item {
                 box-sizing: border-box;
                  display: flex;
                  flex-direction: column;
                justify-content: center;
                align-items: center;
               
                  width: 25%;
                .notaryServices_content_szh_item_img{
                     box-sizing: border-box;
                    width: 56px;
                    height: 42px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .notaryServices_content_szh_item_text {
                     box-sizing: border-box;
                    margin-top: 21px;
                    margin-bottom: 53px;
                    font-size: 20px;
                    color: #313A4B;
                    font-weight: 600;
                }
            }
        }
        .notaryServices_gzyw {
             box-sizing: border-box;
            display: flex;
            margin-top: 30px;
            .notaryServices_gzywimg {
                 box-sizing: border-box;
                width: 386px;
                height: 444px;
                .notaryServices_background {
                     box-sizing: border-box;
                      border-top-left-radius:20px;
                      border-bottom-left-radius:20px;
                    width: 100%;
                    height: 100%;
                    background: url(../../assets/images/notaryServicers/gzsx.png) no-repeat;
                    background-size: 100% 100%;
                    font-weight: 600;
                    font-size: 30px;
                    color: #FFFFFF;
                    padding-top: 46px;
                    padding-left: 58px;
                }
                // margin-right: 30px;
                // img {
                //     width: 100%;
                //     height: 100%;
                // }
            }
            .notaryServices_gzywtext {
                box-sizing: border-box;
                flex: 1;
                background: #F9FAFC;
                padding: 0 30px;
             .notaryServices_gzywtext_title{
                 box-sizing: border-box;
                font-weight: 600;
                font-size: 16px;
                color: #313A4B;
                margin: 20px 0 25px 0 ;


             }
             .notaryServices_gzywtext_item {
                display: flex;
                flex-wrap: wrap;
                justify-content:space-between;
                 box-sizing: border-box;
                .notaryServices_gzywtext_item_flex {
                     box-sizing: border-box;
                    width: 100%;
                    height: 100%;
                     width: 19%;
                    // padding: ;
                  .grid-content {
                    box-sizing: border-box;
                    border-radius: 4px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 80px;
                    box-shadow: 0px 2px 4px 0px rgba(208,208,208,0.5);
                    border: 1px solid #E4E9F3;
                    .grid-content_img {
                    width: 54px;
                    height: 54px;
                    margin-right: 5px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .grid-content_text {
                     box-sizing: border-box;
                    font-weight: 600;
                    font-size: 16px;
                    color: #313A4B;
                }
                }
                }
           
             }

            }
   
        }
    }
    .notaryServices_banner {
         box-sizing: border-box;
        width: 100%;
        height: 400px;
        background: url(../../assets/images/notaryServicers/banner.png) no-repeat;
        background-size:100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .banner_title {
            font-size: 46px;
            font-weight: bold;
            color: #FFFFFF;
        }
        .banner_text {
            margin-top: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #FFFFFF;
        }
    }
}
    // .el-row {
    // margin-bottom: 20px;
    // box-sizing: border-box;
    // }
    // .el-row:last-child {
    // margin-bottom: 0;
    // }



    @media (min-width: 1680px) {

    .notaryServices{
        .notaryServices_content {
            width: 1600px;
             margin: 0 auto;
        }
        
    }
    }
    .btn {
        width: 134px;
        height: 40px;
        background: #0754BD;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        cursor:pointer;
    }
    
</style>